import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBoxProps {
  defaultValue?: string;
  placeholder?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function SearchBox({
  defaultValue = '',
  placeholder = '搜索片名、主演或类型…',
  size = 'md',
  className = '',
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const sizeClass =
    size === 'lg'
      ? 'h-12 text-base pl-11 pr-24'
      : size === 'sm'
        ? 'h-9 text-sm pl-9 pr-14'
        : 'h-11 text-sm pl-10 pr-20';

  const iconClass = size === 'lg' ? 'text-lg left-4' : size === 'sm' ? 'text-base left-3' : 'text-base left-3.5';

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : '/search');
  };

  return (
    <form onSubmit={handleSubmit} className={`relative w-full ${className}`} role="search">
      <i
        className={`ri-search-line absolute top-1/2 -translate-y-1/2 text-foreground-500 ${iconClass}`}
      ></i>
      <input
        type="search"
        name="q"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索电影"
        className={`w-full rounded-full bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-500/30 ${sizeClass}`}
      />
      <button
        type="submit"
        className={`absolute top-1/2 -translate-y-1/2 right-1.5 rounded-full bg-accent-500 hover:bg-accent-600 text-background-50 dark:text-foreground-950 font-medium whitespace-nowrap transition cursor-pointer ${
          size === 'lg' ? 'h-9 px-5 text-sm' : size === 'sm' ? 'h-7 px-3 text-xs' : 'h-8 px-4 text-sm'
        }`}
      >
        搜索
      </button>
    </form>
  );
}